<template>
  <div id="loading-spinner" />
</template>

<script>
import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-vue-popups'
import { mapGetters } from 'vuex'

export default {
  name: 'LoadingSpinner',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      loadingStatus: 'getLoadingStatus'
    })
  },
  watch: {
    loadingStatus (status) {
      if (status) {
        showSpinner(document.getElementById('loading-spinner'))
      } else {
        hideSpinner(document.getElementById('loading-spinner'))
      }
    }
  },
  mounted () {
    createSpinner({
      // Specify the target for the spinner to show
      target: document.getElementById('loading-spinner')
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
